import { render, staticRenderFns } from "./sortList.vue?vue&type=template&id=520a512c&scoped=true&"
import script from "./sortList.vue?vue&type=script&lang=js&"
export * from "./sortList.vue?vue&type=script&lang=js&"
import style0 from "./sortList.vue?vue&type=style&index=0&id=520a512c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a512c",
  null
  
)

export default component.exports